
<div class="login">
  <div class="modal login-modal">
    <LoginSMSModal :verify="true" />
    <LoginLineModal v-if="isLineLogin" :key="lineKey" />
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-card">
      <section class="modal-card-body">
        <h1 class="title has-text-link is-4">{{ msg }}</h1>
        <div>
          <a class="button is-warning is-medium is-fullwidth" @click="openSMSLoginModal">
            <i class="fa fa-sms fa-lg"></i>
            &nbsp;{{ $t("login.login") }}
          </a>
        </div>
        <div v-if="notIOSApp">
          <!-- <div v-if="false"> -->
          <br />
          <div>
            <fb-signin-button :params="fbParams" @success="fbSuccess" @error="fbError">
              <a class="button is-link is-medium is-fullwidth" @click="fbLoading">
                <i class="fab fa-facebook fa-lg"></i>
                &nbsp;{{ $t("login.login") }}
              </a>
            </fb-signin-button>
          </div>
          <br />
          <div>
            <a class="button is-success is-medium is-fullwidth" @click="openLineLoginModal">
              <i class="fab fa-line fa-lg"></i>
              &nbsp;{{ $t("login.login") }}
            </a>
          </div>
        </div>

        <!-- style="height:50px" -->
        <!-- </div> -->
        <!-- <div v-show="showLoginOption('line')">
          <a class="button is-success is-fullwidth" href="http://nav.cx/5n0PM2V">
            <i class="fab fa-line fa-2x"></i>&nbsp;Login
          </a>
          <br />
        </div>-->
      </section>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
  </div>
</div>
